import React, { useEffect, useMemo } from 'react'
import { Box, TextField, Button, Grid, FormControl, InputLabel, Select, MenuItem,
} from '@mui/material';
import { useForm, Controller } from "react-hook-form";
import { useSnackbar } from 'notistack';
import { addRole, updateRole } from 'services/roles';

const EditRole = ({ roleDetails, onSuccess, onFailure }) => {

  const defaultFormFields = useMemo(() => ({
    role: '',
    context: '',
  }),[]);

 
  const { enqueueSnackbar } = useSnackbar();

  const { handleSubmit, control, formState: { errors }, reset } = useForm({
    mode: 'onTouched',
    defaultValues: {...defaultFormFields}
  });

  useEffect(() => {
    if(roleDetails){
      const data = {
        role: roleDetails?.role,
        context: roleDetails?.context,
      }
      reset({...data});
    }
  }, [roleDetails, reset]);

  const resetForm = () => {
    reset({...defaultFormFields});
  };

  const onSubmit = (data) => {
    if(roleDetails?.roleId){
      updateRoleDetails(data);
    }else{
      saveRoleDetails(data);
    }
  }

  const saveRoleDetails = (data) => {
    addRole({
      ...data,
    }).then(({response, error}) => {
      if(error){
        enqueueSnackbar((response?.message || error), {variant: 'error'});
        onFailure()
      } else {
        enqueueSnackbar(`Role added successfully`, {variant: 'success'});
        resetForm();
        onSuccess()
      }
    });
  }

  const updateRoleDetails = (data) => {
    updateRole({
      ...data,
      roleId: roleDetails?.roleId
    }).then(({response, error}) => {
      if(error){
        enqueueSnackbar((response?.message || error), {variant: 'error'});
        onFailure()
      } else {
        enqueueSnackbar(`Role updated successfully`, {variant: 'success'});
        resetForm();
        onSuccess()
      }
    });
  }

  return (
    <Box noValidate component="form"  onSubmit={handleSubmit(onSubmit)} sx={{ mt: 2 }} >
      <Grid container columnSpacing={2} rowSpacing={2} justifyContent="center">
        <Grid  item xs={12} sm={12} md={12} lg={12}>
          <Controller
            control={control}
            name="role"
            id="role"
            rules={{ required: "Enter role name" }}
            render={({field}) => (
              <TextField
                {...field}
                margin="normal"
                label="Role Name"
                required
                error={!!errors?.role}
                size="small"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} sm={11} md={10} lg={12} sx={{mt: 2}}>
          <Controller
            control={control}
            name="context"
            id="context"
            rules={{ required: "Select context"}}
            render={({field}) => (
              <FormControl fullWidth  {...field} error={!!errors?.context}>
                <InputLabel required id="context-select-label" size="small">Context</InputLabel>
                <Select
                  required
                  size="small"
                  labelId="context-select-label"
                  id="context-select"
                  label="Context"
                  value={field?.value}
                  onChange={field.onChange}
                  fullWidth
                >
                  <MenuItem value="VENDOR">Vendor</MenuItem>
                  <MenuItem value="ADMIN">Admin</MenuItem>
                  <MenuItem value="USER">User</MenuItem>
                </Select>
              </FormControl>
            )}
          />
        </Grid>
          
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Button
            type="submit"
            variant="contained"
            sx={{ mt: 3, mb: 2, textTransform: 'inherit' }}
            color="primary"
          >
            {roleDetails ? 'Update' : 'Add'}
          </Button>
        </Grid>


        </Grid>
    </Box>
  );
}
 
export default React.memo(EditRole);
